import { ChevronDown } from "react-feather";
import { Col, Row } from "reactstrap";
import { Filters } from "../../../../../constants";
import { useAppDispatch } from "../../../../../reduxToolkit/hooks";
import { setIsFilter } from "../../../../../reduxToolkit/reducers/eCommerce/filterSlice";
import ViewToggle from "./ViewToggle";
import DisplayOptions from "./DisplayOptions";
import SortOptions from "./SortOptions";

// Render the Summary component with filters, view toggle, display options, and sort options.
const Summary = () => {
  const dispatch = useAppDispatch();

  return (
    <Row>
      <Col md="6" className="products-total">
        <ViewToggle />
        <span className="d-none-productlist filter-toggle">
          {Filters}
          <span className="ms-2" onClick={() => dispatch(setIsFilter())}>
            <ChevronDown className="toggle-data" />
          </span>
        </span>
        <DisplayOptions />
      </Col>
      <SortOptions />
    </Row>
  );
};

export default Summary;
